<div class="sa-mv sa-form-container">
    <div class="sa-mv-wrapper">
        <div class="sa-mv-title" [ngClass]="props.state">
            @if(props.icon){
            <sa-icon [icon]="props.icon" size="24"></sa-icon>
            }
            <div class="title" [ngClass]="props.state">{{props.title}}</div>
        </div>

        @if(props.items && props.items.length){

            @for (item of props.items; track item) {

                @if(item.inlineItems && item.inlineItems.length){
                    <div class="" [ngClass]="item.className">
                    @for (inline of item.inlineItems; track inline) {
                        
                        @switch (inline.type) {
                            @case ('TEXT') {
                                <span class="text" [ngClass]="inline.className">{{inline.text}}</span>&nbsp;
                            }
                            @case ('LINK') {
                                <a class="link sa-mv-link" 
                                    (click)="linkClick(inline.link, inline.link?.event === 'RESEND' && !!timerSeconds)" 
                                    [ngClass]="(inline.className || '') + ' ' + (inline.link?.event === 'RESEND' && !!timerSeconds ? 'disabled' : '')">
                                    {{inline.link?.text || ''}}
                                </a>&nbsp;
                                @if(inline.link?.event === 'RESEND' && !!timerSeconds){
                                <span class="">00:{{timerSeconds}}</span>
                                }
                            }
                            @case ('EMAIL') {
                                <span class="" [ngClass]="inline.className">{{inline.email}}</span>&nbsp;
                            }
                        }
                    }
                    </div>
                }@else{
                    @switch (item.type) {
                        @case ('TEXT') {
                            @if(item.text){<div class="text" [ngClass]="item.className">{{item.text}}</div>}
                        }
                        @case ('EMAIL') {
                            @if(item.email){<div class="" [ngClass]="item.className">{{item.email}}</div>}
                        }
                        @case ('LINK') {
                            <a class="link flex text-14 sa-mv-link" [ngClass]="(item.className || '') + ' ' + (item.link?.event === 'RESEND' && !!timerSeconds ? 'disabled' : '')" (click)="linkClick(item.link, item.link?.event === 'RESEND' && !!timerSeconds)">
                                @if(item.link?.icon){
                                    <sa-icon [icon]="item.link?.icon || ''" class="flex" color="" size="16"></sa-icon>
                                    <span>{{item.link?.text || ''}}</span>
                                    @if(item.link?.event === 'RESEND' && !!timerSeconds){
                                    &nbsp;<span class="">00:{{timerSeconds}}</span>
                                    }
                                }
                            </a>
                        }
                        @case('BUTTON'){
                            <div class="sa-mv-button" [ngClass]="item.className">
                                <sa-button [text]="item?.text || ''" type="primary" size="medium" width="100%" (click)="buttonClick(item)"></sa-button>
                            </div>
                        }
                    }
                }
            }
        }

    </div>
</div>